import { createSelector, createSlice } from '@reduxjs/toolkit';

let localPinnedPoints;

try {
  localPinnedPoints = JSON.parse(localStorage.getItem('pinnedPoints')) || [];
} catch (e) {
  console.warn(e);
}

/**
 * @typedef {{
 *  pinnedPoints?: number[];
 *  contextMenuPointId?: number | null;
 *  contextMenuCoords?: { x: number; y: number } | null;
 * }} PointsState
 */

/**
 * @type {PointsState}
 */
const initialState = {
  pinnedPoints: localPinnedPoints,
  contextMenuPointId: null,
  contextMenuCoords: null,
};

// there are a lot of point related things in other slices, could move them here eventually if we want

export const pointsSlice = createSlice({
  name: 'points',
  initialState,

  reducers: {
    togglePinnedPoint(state, action) {
      const pointId = action.payload;
      // if it's in the array, remove it
      // else add it
      const { pinnedPoints } = state;
      let result;
      if (pinnedPoints.includes(pointId)) {
        result = {
          ...state,
          pinnedPoints: pinnedPoints.filter((id) => id !== pointId),
        };
      } else {
        result = {
          ...state,
          pinnedPoints: [...state.pinnedPoints, pointId],
        };
      }
      // running a side effect in a reducer is highly frowned upon, but does it really matter?  If so, we can do this before the reducer in a thunk like filtersSlice
      try {
        localStorage.setItem(
          'pinnedPoints',
          JSON.stringify(result.pinnedPoints),
        );
      } catch (e) {
        console.warn('Could not store pinned points in localStorage', e);
      }
      return result;
    },
    /**
     *
     * @param {PointsState} state
     * @param {import('@reduxjs/toolkit').PayloadAction<{
     *  pointId: PointsState['contextMenuPointId'];
     *  position: PointsState['contextMenuCoords']
     * } | null>} action
     */
    setContextMenu(state, action) {
      if (action.payload === null) {
        state.contextMenuPointId = null;
        state.contextMenuCoords = null;
        return;
      }
      state.contextMenuPointId = action.payload.pointId;
      state.contextMenuCoords = action.payload.position;
    },
  },
});

/**
 *
 * @param {{points: PointsState}} state
 * @returns {PointsState}
 */
export const selectPointsState = (state) => state.points ?? {};

export const selectPinnedPoints = createSelector(
  selectPointsState,
  (pointsState) => pointsState.pinnedPoints || [],
);

export const selectPointContextMenu = createSelector(
  selectPointsState,
  (pointsState) => ({
    pointId: pointsState.contextMenuPointId,
    coords: pointsState.contextMenuCoords,
  }),
);

export const { togglePinnedPoint, setContextMenu } = pointsSlice.actions;

export default pointsSlice.reducer;
